<template>
  <div class="dangJianShe">
    <el-form :model="ruleForm" :rules="rules" :disabled="true" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="title-flex">
            <b>法定代表人</b>
            <div class="tips">
              <i class="iconfont icon-xinxitishi"></i>注：与市场监管部门登记的法定代表人一致，如变更法定代表人需及时修改
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人姓名" ref="faren_name" prop="faren_name">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.faren_name" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人身份证号" ref="faren_idcard" prop="faren_idcard">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.faren_idcard" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人联系电话" ref="faren_phone" prop="faren_phone">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.faren_phone" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="title-flex">
            <b>教学点负责人</b>
            <div class="tips">
              <i class="iconfont icon-xinxitishi"></i>注：校区行政负责人、校长
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="教学点负责人姓名" ref="fuzeren_name" prop="fuzeren_name">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.fuzeren_name" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="教学点负责人身份证号" ref="fuzeren_idcard" prop="fuzeren_idcard">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.fuzeren_idcard" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="教学点负责人联系电话" ref="fuzeren_phone" prop="fuzeren_phone">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.fuzeren_phone" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="title-flex">
            <b>实际控制人</b>
            <div class="tips">
              <i class="iconfont icon-xinxitishi"></i>注：不在市场监管部门登记备案，但对机构具有实际控制权限
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际控制人姓名" ref="kongzhi_name" prop="kongzhi_name">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.kongzhi_name" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际控制人身份证号" ref="kongzhi_idcard" prop="kongzhi_idcard">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.kongzhi_idcard" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际控制人联系电话" ref="kongzhi_phone" prop="kongzhi_phone">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.kongzhi_phone" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
<!--        <el-col :span="24">-->
<!--          <div class="btn-box">-->
<!--            <div class="btn" @click="submitForm('ruleForm')">保存</div>-->
<!--          </div>-->
<!--        </el-col>-->

      </el-row>
    </el-form>

    <el-divider></el-divider>

    <el-form :model="ruleForm" label-position="top" class="ruleFormYan">
      <div v-for="(item,index) in ruleForm.gdList" :key="item.id">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="title-flex">
              <b>股东</b>
              <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="add()" alt="">
              <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="del(index)" alt="">
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="股东名称" :ref="'gdList.' + index + '.name'" :prop="'gdList.' + index + '.name'" :rules="{
      required: false, message: '请输入', trigger: 'blur'
    }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.name" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="false">
            <el-form-item label="持股比例"
                          :ref="'gdList.' + index + '.bili'"
                          :prop="'gdList.' + index + '.bili'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.bili" class="inp">
                  <template slot="append">%</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认缴出资额"
                          :ref="'gdList.' + index + '.ren_money'"
                          :prop="'gdList.' + index + '.ren_money'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.ren_money" class="inp">
                  <template slot="append">万元</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认缴出资日期"
                          :ref="'gdList.' + index + '.ren_date'"
                          :prop="'gdList.' + index + '.ren_date'"
                          :rules="{
                                required: false, message: '请选择', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-date-picker
                  class="inp"
                  v-model="item.ren_date"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="认缴出资方式"
                          :ref="'gdList.' + index + '.ren_type'"
                          :prop="'gdList.' + index + '.ren_type'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.ren_type" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实缴出资额"
                          :ref="'gdList.' + index + '.shi_money'"
                          :prop="'gdList.' + index + '.shi_money'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.shi_money" class="inp">
                  <template slot="append">万元</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实缴出资日期"
                          :ref="'gdList.' + index + '.shi_date'"
                          :prop="'gdList.' + index + '.shi_date'"
                          :rules="{
                                required: false, message: '请选择', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-date-picker
                  class="inp"
                  v-model="item.shi_date"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实缴出资方式"
                          :ref="'gdList.' + index + '.shi_type'"
                          :prop="'gdList.' + index + '.shi_type'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.shi_type" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="false">
            <el-form-item label="首次持股日期"
                          :ref="'gdList.' + index + '.first_date'"
                          :prop="'gdList.' + index + '.first_date'"
                          :rules="{
                                required: false, message: '请选择', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-date-picker
                  class="inp"
                  v-model="item.first_date"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="btn-box">
      <div class="btn" @click="gudongSub()">保存</div>
    </div>
  </div>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {isYes} from "@/utils/const";
import rules from "@/utils/rules";
import {
  save_contact,
  get_yunying,
  save_gudong
} from "@/api/admin";

export default {
  name: "lianxiren",
  data() {
    return {
      org_id: '',
      isYes: isYes,
      ruleForm: {
        faren_name: '', //
        faren_idcard: '', //
        faren_phone: '', //
        fuzeren_name: '', //
        fuzeren_idcard: '', //
        fuzeren_phone: '', //
        kongzhi_name: '', //
        kongzhi_idcard: '', //
        kongzhi_phone: '', //
        gdList: [{
          name: '',
          bili: '',
          ren_money: '',
          ren_date: '',
          ren_type: '',
          shi_money: '',
          shi_date: '',
          shi_type: '',
          first_date: '',
          id: Date.now()
        }]
      },
      rules: {
        kongzhi_phone: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.phone
        ],
        kongzhi_idcard: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.idCard
        ],
        kongzhi_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        fuzeren_phone: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.phone
        ],
        fuzeren_idcard: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.idCard
        ],
        fuzeren_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        faren_phone: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.phone
        ],
        faren_idcard: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.idCard
        ],
        faren_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        is_kaili: [
          {required: false, message: '请选择', trigger: 'change'}
        ]
      }
    }
  },
  components: {},
  created() {
    this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {
    async init() {
      let _data = await get_yunying(this.org_id, 2);
      if (_data.status == 200) {
        this.ruleForm = {
          faren_name: _data.data.faren_name, //
          faren_idcard: _data.data.faren_idcard, //
          faren_phone: _data.data.faren_phone, //
          fuzeren_name: _data.data.fuzeren_name, //
          fuzeren_idcard: _data.data.fuzeren_idcard, //
          fuzeren_phone: _data.data.fuzeren_phone, //
          kongzhi_name: _data.data.kongzhi_name, //
          kongzhi_idcard: _data.data.kongzhi_idcard, //
          kongzhi_phone: _data.data.kongzhi_phone, //
          gdList: _data.data.gdList.length ? _data.data.gdList : [{
            name: '',
            bili: '',
            ren_money: '',
            ren_date: '',
            ren_type: '',
            shi_money: '',
            shi_date: '',
            shi_type: '',
            first_date: '',
            id: Date.now()
          }]
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },

    async submitInfo() {
      let _data = await save_contact(
        this.org_id,
        this.ruleForm.faren_name,
        this.ruleForm.faren_idcard,
        this.ruleForm.faren_phone,
        this.ruleForm.fuzeren_name,
        this.ruleForm.fuzeren_idcard,
        this.ruleForm.fuzeren_phone,
        this.ruleForm.kongzhi_name,
        this.ruleForm.kongzhi_idcard,
        this.ruleForm.kongzhi_phone
      )
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    async gudongSub() {
      let _data = await save_gudong(
        this.org_id,
        JSON.stringify(this.ruleForm.gdList)
      )
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },

    add() {
      this.ruleForm.gdList.push({
        name: '',
        bili: '',
        ren_money: '',
        ren_date: '',
        shi_money: '',
        shi_date: '',
        first_date: '',
        id: Date.now()
      })
    },
    del(index) {
      this.ruleForm.gdList.splice(index, 1)
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .width {
    width: 400px;
  }

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }

  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }
}
</style>


